import React from 'react';
import PhotoStripSection from '../../PhotoStripSection';
import PlayMetadataSection from '../../PlayMetadataSection';
import { MetadataFieldDefinition } from '../../../generated-api';

interface DetailsStepProps {
  comment: string;
  onCommentChange: (comment: string) => void;
  durationMinutes: number | null;
  onDurationChange: (minutes: number | null) => void;
  playImages: File[];
  onPlayImagesChange: (images: File[]) => void;
  teams: string[];
  teamMetadata: Record<string, Record<string, any>>;
  onTeamMetadataChange: (metadata: Record<string, Record<string, any>>) => void;
  playerMetadataFields?: MetadataFieldDefinition[];
  playDate?: string;
  onPlayDateChange?: (date: string) => void;
}

const DetailsStep: React.FC<DetailsStepProps> = ({
  comment,
  onCommentChange,
  durationMinutes,
  onDurationChange,
  playImages,
  onPlayImagesChange,
  teams,
  teamMetadata,
  onTeamMetadataChange,
  playerMetadataFields,
  playDate = '',
  onPlayDateChange,
}) => {
  const showDate = !!onPlayDateChange;

  return (
    <div className="flex flex-col gap-5">
      <div className="p-4 rounded-xl border border-edge bg-surface">
        <PlayMetadataSection
          playDate={playDate}
          onPlayDateChange={onPlayDateChange ?? (() => {})}
          hideDateButton={!showDate}
          comment={comment}
          onCommentChange={onCommentChange}
          durationMinutes={durationMinutes}
          onDurationChange={onDurationChange}
          teams={teams}
          teamMetadata={teamMetadata}
          onTeamMetadataChange={onTeamMetadataChange}
          onMetadataSave={onTeamMetadataChange}
          playerMetadataFields={playerMetadataFields}
        />
      </div>

      {/* Photos */}
      <PhotoStripSection
        playImages={playImages}
        existingImages={[]}
        onPlayImagesChange={onPlayImagesChange}
      />
    </div>
  );
};

export default DetailsStep;
